import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/">
            <img src="/logo.png" alt="ELDR Logo" className="logo-image" />
          </Link>
        </div>

        <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <ul className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <li><Link to="/" className="navbar-link">Home</Link></li>
          <li><Link to="/about" className="navbar-link">About ELDR-US</Link></li>
          <li><a href="#services" className="navbar-link">Services</a></li>
          <li><a href="#products" className="navbar-link">New Product</a></li>
          <li><a href="#blog" className="navbar-link">Company Blog</a></li>
          <li><a href="#jobs" className="navbar-link">Job Opportunities</a></li>
          <li><a href="#contact" className="navbar-link">Contact Us</a></li>
          <li><a href="/login" className="navbar-login">Log-In</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
